import { render, staticRenderFns } from "./dialogCourse.vue?vue&type=template&id=d50fffdc&scoped=true&"
import script from "./dialogCourse.vue?vue&type=script&lang=js&"
export * from "./dialogCourse.vue?vue&type=script&lang=js&"
import style0 from "./dialogCourse.vue?vue&type=style&index=0&id=d50fffdc&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d50fffdc",
  null
  
)

export default component.exports